import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { connect } from "react-redux";
import moment from 'moment';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import { merchantAdminHeadings, merchantHeadings } from '../../../utils/constants';
import { tableHeadings } from '../../../utils/constants';


import { fetchAllMerchants, fetchMerchantInfo, setModified, setMerchantID, setMerchantEdit } from '../../../redux/actions/MerchantActions';
import { fetchMerchantTerminal, fetchTerminal, setTerminalEdit, setTerminalID, getAllTerminals } from '../../../redux/actions/TerminalActions';
import { fetchMerchantTransactions } from '../../../redux/actions/TransactionActions';

import TableView from '../Table/Table';
import AddEditProcessingGroups from '../ProcessingGroups/AddEditProcessingGroups';


const MerchantView = (props) => {

    const navigate = useNavigate();

    // eslint-fix: preserve loose-equality coercion
    const heading = Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? merchantAdminHeadings : merchantHeadings

    // eslint-fix: preserve loose-equality coercion
    const terminalHeading = Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? tableHeadings.adminTerminalsSubList : tableHeadings.terminalsSubList;


    useEffect(() => {
        let id = props.MERCHANTREDUCER.merchantID
        console.log(id)
        if (id) {
            props.fetchMerchantInfo(id)
            props.fetchMerchantTerminal(id)
            props.fetchMerchantTransactions(id)
        }
        props.setModified(false)

        return () => {
            props.setMerchantEdit(false)
            props.getAllTerminals([])
        }
    }, [])


    const handleTerminalClick = (value) => {
        props.setTerminalID(value.data.terminalID)
        navigate('/terminal/view')
    }


    const handleEditClick = () => {
        navigate('/merchant/edit')
    }

    return (


        <div className="row mb-3">

            <div className="col-xl-4">
                <Panel>
                    <PanelHeader>
                        <div className="row mb-0">
                            <div className="col-xl-10">
                                MERCHANT PROFILE
                            </div>
                            <div className="col-xl-2">
                                {/* eslint-fix: preserve loose-equality coercion */}
                                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary btn-xs' onClick={handleEditClick}>Edit</button> : null}
                            </div>
                        </div>
                    </PanelHeader>

                    <PanelBody>

                        <div className="table-responsive">

                            <table className="table mb-0">
                                <tbody>

                                    {props.MERCHANTREDUCER.merchantInfo && props.MERCHANTREDUCER.merchantInfo.length ? Object.keys(heading).map(data => {
                                        let key = data.includes('contact') || data.includes("address") ? data.split(".") : data
                                        if (typeof (key) != 'object') {
                                            if (props.MERCHANTREDUCER.merchantInfo[0][key] && props.MERCHANTREDUCER.merchantInfo[0][key].toString()) {
                                                if (key === 'merchantStatusID') {
                                                    return (

                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            {/* eslint-fix: preserve loose-equality coercion */}
                                                            <td className={Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 1 ? 'approved' : Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 2 ? 'suspended' : Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 3 ? 'inactive' : 'reject'}>{Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 1 ? 'Active' : Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 2 ? 'Suspended' : Number(props.MERCHANTREDUCER.merchantInfo[0][key]) === 3 ? 'InAcive' : 'Deleted'}</td>
                                                        </tr>
                                                    )
                                                } else if (key === 'multipleTID') {
                                                    return (
                                                        <tr key={data}>
                                                            <th >{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.MERCHANTREDUCER.merchantInfo[0][key] === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                    )


                                                } else {
                                                    return (
                                                        <tr key={data}>
                                                            <th>{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{key.toLowerCase() === ('createdate') || key.toLowerCase() === ('lastupdated') ? moment(props.MERCHANTREDUCER.merchantInfo[0][key]).format('MMM DD, YYYY HH:MM:SS') : key.toLowerCase().includes('password') ?
                                                                <input
                                                                    margin="normal"
                                                                    type='password'
                                                                    name="tempPassword"
                                                                /> : props.MERCHANTREDUCER.merchantInfo[0][key]}</td>
                                                        </tr>
                                                    )
                                                }

                                            }
                                        } else {
                                            if (props.MERCHANTREDUCER.merchantInfo[0][key[0]] && props.MERCHANTREDUCER.merchantInfo[0][key[0]][key[1]]) {
                                                return (
                                                    <tr>
                                                        <th>{heading[data]}</th>
                                                        <th>:</th>
                                                        <td>{props.MERCHANTREDUCER.merchantInfo[0][key[0]][key[1]] ? props.MERCHANTREDUCER.merchantInfo[0][key[0]][key[1]] : '-'}</td>
                                                    </tr>
                                                )
                                            }
                                        }
                                        return null
                                    }
                                    ) : null}
                                </tbody>
                            </table>
                        </div>

                    </PanelBody>
                </Panel>
            </div>


            <div className="col-xl-8">
                <Panel>
                    <PanelHeader><b>TERMINALS</b></PanelHeader>
                    <TableView height={535} headings={terminalHeading} data={props.TERMINALREDUCER.terminalsData} handleClick={handleTerminalClick} />
                </Panel>
            </div>

            <div className="col-xl-12">
                {/* eslint-fix: preserve loose-equality coercion */}
                {([1,6,7].includes(props.LOGINREDUCER.USER.role) &&  Number(props.MERCHANTREDUCER.merchantInfo[0]?.multipleTID) === 1) ?
                    <AddEditProcessingGroups></AddEditProcessingGroups>
                    : null
                }
            </div>

            <div className="col-xl-12">
                <Panel>
                    <PanelHeader><b>TRANSACTIONS</b></PanelHeader>
                    <TableView height={563} count={12} headings={tableHeadings.merchantTransactions} data={props.TRANSACTIONREDUCER.transactionsData} />

                </Panel>
            </div>

        </div>
    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllMerchants,
    fetchMerchantInfo,
    fetchMerchantTerminal,
    fetchTerminal,
    setMerchantEdit,
    setTerminalEdit,
    setTerminalID,
    setMerchantID,
    setModified,
    getAllTerminals,
    fetchMerchantTransactions

}


export default connect(mapStateToProps, mapDispatchToProps)(MerchantView);